import { API } from 'aws-amplify';
import { DOCUMENT_MANAGEMENT_BASE_URL_APPEND } from 'constants';

export const getSharedFolders = async () => {
  const sharedFolders = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders`
  );
  return sharedFolders;
};

export const getSharedFolder = async (sharedFolderId) => {
  const sharedFolders = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}`
  );
  return sharedFolders;
};

export const postSharedFolder = async (payload) => {
  const myPayload = {
    body: payload,
  };
  await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders`,
    myPayload
  );
};

export const putSharedFolder = async (payload, sharedFolderId) => {
  const myPayload = {
    body: payload,
  };
  await API.put(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}`,
    myPayload
  );
};

export const getSharedFolderVersions = async (sharedFolderId) => {
  const sharedFolderVersions = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}/versions`
  );
  return sharedFolderVersions;
};

export const putSharedFolderUserAccess = async (payload, sharedFolderId) => {
  const myPayload = {
    body: payload,
  };
  await API.put(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}/userAccess`,
    myPayload
  );
};

export const putSharedFolderGroupAccess = async (payload, sharedFolderId) => {
  const myPayload = {
    body: payload,
  };
  await API.put(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}/groupAccess`,
    myPayload
  );
};

export const getSharedFoldersArchive = async (
  pageSize,
  paginationKey,
  oldestFirst
) => {
  const sharedFoldersArchive = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFoldersArchive?`,
    {
      headers: {},
      queryStringParameters: {
        limit: pageSize,
        paginationKey: paginationKey,
        oldestFirst: oldestFirst,
      },
    }
  );
  return sharedFoldersArchive;
};

export const postSharedFolderArchive = async (sharedFolderId) => {
  await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}/archive`
  );
};

export const postSharedFoldersUnarchive = async (sharedFolderId) => {
  await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}sharedFolders/${sharedFolderId}/restore`
  );
};

//Employee Documents API's
export const getEmploymentDocs = async (employee, company, includeExpired) => {
  const employmentDocs = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/company/${company}?includeExpired=${includeExpired}`
  );
  return employmentDocs;
};

export const getStagedEmployeeDocuments = async (employee) => {
  const stagedEmployeeDocuments = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/staging`
  );
  return stagedEmployeeDocuments;
};

export const postStagedDocumentUpload = async (employee, payload) => {
  const myPayload = {
    body: payload,
  };
  const stagedDocumentUploadUrl = await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/staging`,
    myPayload
  );
  return stagedDocumentUploadUrl;
};

export const postAssociateDocument = async (payload, employee, company) => {
  const myPayload = {
    body: payload,
  };
  await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/company/${company}`,
    myPayload
  );
};

export const postDownloadEmploymentDocument = async (
  employee,
  company,
  filename
) => {
  const downloadLink = await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/company/${company}/${filename}`
  );
  return downloadLink;
};

export const postDownloadStagedDocument = async (employee, filename) => {
  const downloadLink = await API.post(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/staging/${filename}`
  );
  return downloadLink;
};

export const deleteStagedDocument = async (employee, filename) => {
  await API.del(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/staging/${filename}`
  );
};

export const deleteEmploymentDocument = async (employee, company, filename) => {
  await API.del(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/${employee}/company/${company}/${filename}`
  );
};

export const getDocumentTypes = async () => {
  const documentTypes = await API.get(
    'delta-api',
    `${DOCUMENT_MANAGEMENT_BASE_URL_APPEND}employmentDocs/documentTypes`
  );
  return documentTypes;
};
